// components/orders/CreateOrderModal.js
import React, { useState, useMemo } from 'react';
import { formatRestaurantPrice, normalizeCurrency } from '../../utils/formatPrice';

export default function CreateOrderModal({
  menuItems,
  categories = [],
  menuCurrency = 'UZS',
  onClose,
  onSubmit,
  loading,
}) {
  const cur = normalizeCurrency(menuCurrency);
  const [tableNumber, setTableNumber] = useState('');
  const [search, setSearch]           = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [cart, setCart]               = useState({}); // { menuItemId: quantity }
  const [comment, setComment]         = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    return menuItems.filter((i) => {
      const matchSearch = !q || (i.name_ru || i.name || '').toLowerCase().includes(q);
      const matchCat = !selectedCategoryId || i.category_id === selectedCategoryId;
      return matchSearch && matchCat;
    });
  }, [menuItems, search, selectedCategoryId]);

  const addItem = (item) => {
    setCart((prev) => ({ ...prev, [item.id]: (prev[item.id] || 0) + 1 }));
  };

  const changeQty = (id, delta) => {
    setCart((prev) => {
      const next = (prev[id] || 0) + delta;
      if (next <= 0) {
        const { [id]: _, ...rest } = prev;
        return rest;
      }
      return { ...prev, [id]: next };
    });
  };

  const cartItems = menuItems.filter((i) => cart[i.id] > 0);
  const totalAmount = cartItems.reduce((s, i) => s + i.price * cart[i.id], 0);

  const handleSubmit = () => {
    if (cartItems.length === 0) return;
    onSubmit({
      tableNumber: tableNumber || null,
      items: cartItems.map((i) => ({ menuItemId: i.id, quantity: cart[i.id] })),
      notes: comment.trim() || undefined,
    });
  };

  const qBtn = (bg, color) => ({
    width: '28px', height: '28px', borderRadius: '8px',
    border: 'none', backgroundColor: bg, color,
    fontSize: '16px', fontWeight: '700', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  });

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '20px 20px 0 0',
        width: '100%', maxWidth: '600px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column',
        padding: '20px', boxSizing: 'border-box',
      }} onClick={(e) => e.stopPropagation()}>
        {/* Шапка */}
        <div style={{ display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>
            📋 Новый заказ
          </h2>
          <button onClick={onClose} style={{
            width: '32px', height: '32px', borderRadius: '50%',
            border: 'none', backgroundColor: '#F0F0F0',
            fontSize: '18px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>×</button>
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>

          {/* Номер стола */}
          <div style={{ marginBottom: '14px' }}>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '6px', fontWeight: '600' }}>
              🪑 Номер стола
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {['1','2','3','4','5','6','7','8'].map((n) => (
                <button key={n} onClick={() => setTableNumber(n === tableNumber ? '' : n)}
                  style={{
                    width: '40px', height: '40px', borderRadius: '10px',
                    border: 'none', cursor: 'pointer', fontWeight: '700', fontSize: '14px',
                    backgroundColor: tableNumber === n ? '#000' : '#F0F0F0',
                    color: tableNumber === n ? '#fff' : '#333',
                  }}>{n}</button>
              ))}
              <input
                placeholder="Другой"
                value={['1','2','3','4','5','6','7','8'].includes(tableNumber) ? '' : tableNumber}
                onChange={(e) => setTableNumber(e.target.value)}
                style={{
                  width: '70px', height: '40px', borderRadius: '10px',
                  border: '1px solid #E0E0E0', textAlign: 'center',
                  fontSize: '14px', outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
          </div>

          {/* Поиск блюд */}
          <div style={{ marginBottom: '10px' }}>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '6px', fontWeight: '600' }}>
              🔍 Добавить блюда
            </div>
            <input
              placeholder="Поиск по названию..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%', padding: '10px 12px', borderRadius: '10px',
                border: '1px solid #E0E0E0', fontSize: '14px',
                outline: 'none', boxSizing: 'border-box',
              }}
            />
          </div>

          {/* Фильтр по категориям */}
          {categories.length > 0 && (
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px', overflowX: 'auto', paddingBottom: '4px' }}>
              <button
                onClick={() => setSelectedCategoryId(null)}
                style={{
                  flexShrink: 0, padding: '6px 12px', borderRadius: '100px', border: 'none',
                  backgroundColor: !selectedCategoryId ? '#000' : '#F0F0F0',
                  color: !selectedCategoryId ? '#fff' : '#555',
                  fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                }}
              >
                Все
              </button>
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setSelectedCategoryId(selectedCategoryId === cat.id ? null : cat.id)}
                  style={{
                    flexShrink: 0, padding: '6px 12px', borderRadius: '100px', border: 'none',
                    backgroundColor: selectedCategoryId === cat.id ? '#000' : '#F0F0F0',
                    color: selectedCategoryId === cat.id ? '#fff' : '#555',
                    fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                  }}
                >
                  {cat.name_ru || cat.name}
                </button>
              ))}
            </div>
          )}

          {/* Список меню */}
          <div style={{ marginBottom: '14px', maxHeight: '200px', overflowY: 'auto' }}>
            {filtered.length === 0 && (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>
                Ничего не найдено
              </div>
            )}
            {filtered.map((item) => (
              <div key={item.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '10px 0', borderBottom: '1px solid #F5F5F5',
              }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '14px', fontWeight: '500' }}>
                    {item.name_ru || item.name}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888' }}>
                    {formatRestaurantPrice(item.price, cur)}
                  </div>
                </div>
                {cart[item.id] ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button onClick={() => changeQty(item.id, -1)} style={qBtn('#F0F0F0', '#333')}>−</button>
                    <span style={{ fontSize: '14px', fontWeight: '700', minWidth: '20px', textAlign: 'center' }}>
                      {cart[item.id]}
                    </span>
                    <button onClick={() => changeQty(item.id, +1)} style={qBtn('#000', '#fff')}>+</button>
                  </div>
                ) : (
                  <button onClick={() => addItem(item)} style={{
                    padding: '6px 14px', borderRadius: '8px', border: 'none',
                    backgroundColor: '#000', color: '#fff',
                    fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  }}>+ Добавить</button>
                )}
              </div>
            ))}
          </div>

          {/* Корзина */}
          {cartItems.length > 0 && (
            <div style={{
              backgroundColor: '#F8F8F8', borderRadius: '14px',
              padding: '12px', marginBottom: '14px',
            }}>
              <div style={{ fontSize: '13px', fontWeight: '700', marginBottom: '8px', color: '#555' }}>
                🛒 Выбрано:
              </div>
              {cartItems.map((item) => (
                <div key={item.id} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '6px 0', borderBottom: '1px solid #EFEFEF',
                }}>
                  <div style={{ flex: 1 }}>
                    <span style={{ fontSize: '13px' }}>{item.name_ru || item.name}</span>
                    <span style={{ fontSize: '12px', color: '#999', marginLeft: '6px' }}>
                      × {cart[item.id]}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>
                      {formatRestaurantPrice(item.price * cart[item.id], cur)}
                    </span>
                    <button onClick={() => changeQty(item.id, -1)} style={qBtn('#FFEBEE', '#E85D4A')}>−</button>
                    <button onClick={() => changeQty(item.id, +1)} style={qBtn('#E8F5E9', '#34C759')}>+</button>
                  </div>
                </div>
              ))}
              <div style={{
                display: 'flex', justifyContent: 'space-between',
                fontWeight: '700', fontSize: '15px',
                paddingTop: '10px', marginTop: '4px',
              }}>
                <span>Итого:</span>
                <span>{formatRestaurantPrice(totalAmount, cur)}</span>
              </div>
            </div>
          )}

          {/* Комментарий */}
          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '6px', fontWeight: '600' }}>
              💬 Комментарий
            </div>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Пожелания, аллергии..."
              rows={2}
              style={{
                width: '100%', padding: '10px 12px', borderRadius: '10px',
                border: '1px solid #E0E0E0', fontSize: '14px',
                resize: 'none', outline: 'none', boxSizing: 'border-box',
              }}
            />
          </div>
        </div>

        {/* Кнопки */}
        <div style={{ display: 'flex', gap: '10px', paddingTop: '12px',
          borderTop: '1px solid #F0F0F0',
          paddingBottom: 'max(16px, env(safe-area-inset-bottom))' }}>
          <button onClick={onClose} style={{
            flex: 1, padding: '14px', borderRadius: '12px', border: 'none',
            backgroundColor: '#F0F0F0', color: '#333',
            fontSize: '15px', fontWeight: '600', cursor: 'pointer',
          }}>Отмена</button>
          <button
            onClick={handleSubmit}
            disabled={cartItems.length === 0 || loading}
            style={{
              flex: 2, padding: '14px', borderRadius: '12px', border: 'none',
              backgroundColor: cartItems.length === 0 ? '#ccc' : '#34C759',
              color: '#fff', fontSize: '15px', fontWeight: '700',
              cursor: cartItems.length === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            {loading
              ? '⏳ Создаём...'
              : totalAmount > 0
                ? `✅ Создать заказ · ${formatRestaurantPrice(totalAmount, cur)}`
                : '✅ Создать заказ'}
          </button>
        </div>
      </div>
    </div>
  );
}
